import { DRUG_TIERS_DEFAULT_COST, SINGLE_TERM_COSTS } from "Constants";

export const INITIAL_PLAN_TERM_RATES = {
  ...SINGLE_TERM_COSTS,
  "drug_tier:Tier 1": DRUG_TIERS_DEFAULT_COST.generic,
  "drug_tier:Tier 2": DRUG_TIERS_DEFAULT_COST.brand,
  "drug_tier:Tier 3": NaN,
  "drug_tier:Tier 4": DRUG_TIERS_DEFAULT_COST.specialty,
};
